module.exports = __webpack_public_path__ + "media/images/logos/exchange-89f4fc49d9a909105d0a5a77d488b8c4.svg";